<template>
    <div class="ribbon-root">
        <div class="ribbon-block">
            <div class="ribbon-block-title">{{$t('CEDEX Codes')}}</div>
            <div class="ribbon-button-bar">
                <ribbon-button
                    :text="$t('Location Codes')"
                    :image="require('@/assets/icons/toolbar/codes/location.svg')"
                    :active="selectedCodeType === 'location'"
                    @clicked="updateCodeType('location')"/>
                <ribbon-button
                    :text="$t('Component Codes')"
                    :image="require('@/assets/icons/toolbar/codes/component.svg')"
                    :active="selectedCodeType === 'component'"
                    @clicked="updateCodeType('component')"/>
                <ribbon-button
                    :text="$t('Damage Codes')"
                    :image="require('@/assets/icons/toolbar/codes/damage.svg')"
                    :active="selectedCodeType === 'damage'"
                    @clicked="updateCodeType('damage')"/>
                <ribbon-button
                    :text="$t('Repair Codes')"
                    :image="require('@/assets/icons/toolbar/codes/repair.svg')"
                    :active="selectedCodeType === 'repair'"
                    @clicked="updateCodeType('repair')"/>
                <ribbon-button
                    :text="$t('Material Codes')"
                    :image="require('@/assets/icons/toolbar/codes/material.svg')"
                    :active="selectedCodeType === 'material'"
                    @clicked="updateCodeType('material')"/>
            </div>
        </div>
        <div class="ribbon-block separator"/>
        <div class="ribbon-block">
            <div class="ribbon-block-title">{{$t('View Settings')}}</div>
            <div class="ribbon-button-bar">
                <ribbon-button :text="$t('Display Columns')"  :image="require('@/assets/icons/toolbar/columns.svg')" @clicked="showColumnSelection"/>
                <div class="ribbon-button-two-state-box">
                    <ribbon-button-two-state
                        :text="$t('Other Languages')"
                        :active="this.selectedOtherLanguages"
                        @clicked="toggleOtherLanguages"/>
                </div>
            </div>
        </div>
        <div v-if="allowed.write" class="ribbon-block separator"/>
        <div v-if="allowed.write" class="ribbon-block">
            <div class="ribbon-block-title">{{$t('Actions')}}</div>
            <div class="ribbon-button-bar">
                <ribbon-button
                    v-if="allowed.write"
                    :text="$t('Save')"
                    :image="require('@/assets/icons/toolbar/save.svg')"
                    @clicked="$emit('saveCodes')"/>
                <ribbon-button
                    :text="$t('Add')"
                    :image="require('@/assets/icons/toolbar/add.svg')"
                    @clicked="$emit('addNewCode')"/>
            </div>
        </div>
        <selector-popup
                v-if="selectorItems"
                :items="selectorItems"
                :items-preselect="selectorItemsSelected"
                :item-text="'title'"
                :item-value="'id'"
                :filter="true"
                :filter-mode="'contains'"
                :multi-select="selectorMultiSelect"
                @itemSelected="handleSelectorSelected"
        />
    </div>

</template>

<script>
    import RibbonButton from "./RibbonButton";
    import RibbonButtonTwoState from "./RibbonButtonTwoState";
    import SelectorPopup from "../SelectorPopup.vue";
    import authorization from "../../plugins/authorization";

    export default {
        name: "RibbonTags",
        components: {SelectorPopup, RibbonButton, RibbonButtonTwoState},
        props: {
            otherLanguages: {
                type: Boolean,
                default: false
            },
            columns:        Array,

            codeType:       String,
            codeTypes:      Object,
        },
        data: function() {
            return {
                selectedCodeType:       this.codeType,
                selectedOtherLanguages: this.otherLanguages,

                selectorItems:          null,
                selectorItemsSelected:  null,
                selectorMultiSelect:    null,

                allowed: {
                    read:  authorization.isAllowed('Settings/CEDEX Settings/Dependencies/Editor/View'),
                    write: authorization.isAllowed('Settings/CEDEX Settings/Dependencies/Editor/View', authorization.write),
                },
            };
        },
        computed: {
            selectableCodeTypes() {
                let array = [];
                Object.keys(this.codeTypes).forEach((codeType) => {
                    array.push({
                        id:   codeType,
                        name: this.codeTypes[codeType]
                    })
                });
                return array;
            }
        },
        methods: {
            async updateCodeType(codeType) {
                this.selectedCodeType = codeType;
                if (await this.$confirmLeaveDialog()) {
                    this.$emit('updateView', 'codeType', this.selectedCodeType)
                } else {
                    this.selectedCodeType = this.codeType;
                }
            },
            showColumnSelection() {
                this.selectorItems = this.columns;
                this.selectorItemsSelected = [];
                for (let columnIndex in this.columns) {
                    if (this.columns[columnIndex].visible) {
                        this.selectorItemsSelected.push(this.columns[columnIndex].id);
                    }
                }
                this.selectorMultiSelect = true;
            },
            handleSelectorSelected(selectedColumns) {
                this.selectorItems = null;
                for (let columnIndex in this.columns) {
                    this.columns[columnIndex].visible = selectedColumns.includes(this.columns[columnIndex].id);
                }
            },
            toggleOtherLanguages() {
                this.selectedOtherLanguages = !this.selectedOtherLanguages;
                this.$emit('displayOtherLanguages', this.selectedOtherLanguages);
            }
        },
        created: function() {
            this.$parent.$on('updateView', function(updateType, updateValue) {
                this['selected' + updateType.charAt(0).toUpperCase() + updateType.slice(1)] = updateValue;
            });
        }
    }
</script>

<style scoped>
    div.ribbon-root {
        text-align: left;
        height: 104px;
        background-color: var(--toolbar-background);
    }
    div.ribbon-root > div {
        display: inline-block;
    }
    div.ribbon-block {
        margin-left: 8px;
        margin-right: 8px;
        height: 104px;
        vertical-align: top;
    }
    div.ribbon-block.separator {
        background-color: var(--toolbar-separator);
        width: 1px;
        margin: 8px 0;
        height: 88px;
    }
    div.ribbon-block-title {
        font-size: 12px;
        color: var(--toolbar-label);
        text-align: center;
        padding-top: 8px;
    }
    div.ribbon-select-block {
        display: inline-block;
        padding-top: 8px;
    }
    div.ribbon-select-block:not(:last-child) {
        margin-right: 8px
    }
    div.ribbon-select {
        height: 30px;
        overflow: hidden;
    }
    div.ribbon-select > div {display: inline-block}
    div.ribbon-select-label {
        color: var(--toolbar-label);
        display: inline-block;
        width: 120px;
        font-size: 14px;
        height: 30px;
        vertical-align: top;
        line-height: 220%;
    }
    div.ribbon-button-two-state-box {
        display: inline-block;
        width: 136px;
        height: 72px;
        padding: 8px 0;
    }

</style>